import { PLATFORM } from 'aurelia-pal';
import { Router, RouterConfiguration } from 'aurelia-router';
import { FsApp } from './Lib/Fs.Core.Aurelia/Components/fsapp';

export class App extends FsApp {
  public router: Router;

  public configureRouter(config: RouterConfiguration, router: Router): Promise<void> | PromiseLike<void> | void {
    /*config.title = 'Aurelia';*/
    config.map([
      {
        route: [''],
        redirect: "Modules/Aqs/HomePage",
      },
      {
        route: 'users',
        name: 'users',
        moduleId: PLATFORM.moduleName('./Modules/Sample/Programs/GithubUser/users'),
        nav: true,
        title: 'Github Users',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      },
      //{
      //  route: 'child-router',
      //  name: 'child-router',
      //  moduleId: PLATFORM.moduleName('./Modules/Sample/Programs/ChildRouter/child-router'),
      //  nav: true,
      //  title: 'Child Router',
      //  layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      //},
      {
        route: 'child-router-core',
        name: 'child-router-core',
        nav: true,
        title: 'Core',
        redirect: 'Core/ManageUser'
      },
      {
        route: 'open-layer',
        name: 'open-layer',
        moduleId: PLATFORM.moduleName('./Modules/Sample/Programs/OpenLayer/open-layer'),
        nav: true,
        title: 'Open Layer',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page'),
      },
      {
        route: 'change-password',
        name: 'ChangePassword',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ChangePassword/ChangePasswordVM'),
        nav: false,
        settings: { IsFromLogin: true },
        title: 'Audit Log',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'change-password/TokenNo:/ResourceId:',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ChangePassword/ChangePasswordVM'),
        name: 'ChangePasswordLogin',
        nav: false,
        settings: { IsFromLogin: false },
        title: 'Change Password',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'redirect-success',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ChangePassword/RedirectSuccessVM'),
        name: 'RedirectSuccess',
        nav: false,
        title: 'Redirect Success',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'create-password',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/CreatePassword/CreatePasswordVM'),
        name: 'CreatePassword',
        nav: false,
        title: 'Create Password',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'forget-password',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ForgetPassword/ForgetPasswordVM'),
        name: 'ForgetPassword',
        nav: false,
        title: 'Forget Password',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'activate',
        name: 'Activate',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/Activate/ActivateVM'),
        nav: true,
        title: 'Activate',
        layoutViewModel: PLATFORM.moduleName('Layout/master-page-manageuser'),
      },
      {
        route: 'Core/ManageUser',
        name: 'ManageUser',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ManageUser/ManageUserSearchVM'),
        nav: true,
        title: 'Manage User',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      },
      {
        route: 'audit-log',
        name: 'AuditLog',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/AuditLog/AuditLogSearchVM'),
        nav: true,
        title: 'Audit Log',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      },
      {
        route: 'manage-configuration',
        name: 'ManageConfiguration',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ManageConfiguration/ConfigurationSearchVM'),
        nav: true,
        title: 'Manage Configuration',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      },
      {
        route: 'manage-user-group',
        name: 'ManageUserGroup',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/ManageUserGroup/ManageUserGroupSearchVM'),
        nav: true,
        title: 'Manage User Group',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      },
      {
        route: 'user-detail/:id?',
        name: 'UserDetail',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/UserDetail/UserDetailEditorVM'),
        nav: false,
        title: 'User Detail',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      },
      {
        route: 'user-group-detail/:id?',
        name: 'UserGroupDetail',
        moduleId: PLATFORM.moduleName('./Modules/Core/Programs/UserGroupDetail/UserGroupDetailEditorVM'),
        nav: false,
        title: 'User Group Detail',
        settings: { parentMenu: 'child-router-core' },
        layoutViewModel: PLATFORM.moduleName('Layout/master-page')
      }
    ]);

    this.router = router;
  }
}
